module.exports = __webpack_public_path__ + "static/media/adx.eaf4aaca.svg";